import { FCC } from "@/types/common";
import { TJobWorkingTime } from "@/features/job/types/JobForm";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack, Typography } from "@mui/material";
import { black, red, text } from "@/theme/colors";
import { EMPTY_STR } from "@/constants/string";
import { calculateWorkingTimeItem } from "@/features/job/utils/jobWorkingTime";

type TJobWorkingTimeItemDetail = {
  title: string;
  workingTime: TJobWorkingTime;
  showDivider?: boolean;
};

export const JobWorkingTimeItemDetail: FCC<TJobWorkingTimeItemDetail> = ({ title, workingTime, showDivider = true }) => {
  const getTime = (time: string | null | undefined) => {
    if (time) {
      const [hours, minutes] = time.split(":");
      const formattedHours = hours.padStart(2, "0");
      const formattedMinutes = minutes.padStart(2, "0");
      return `${formattedHours}時${formattedMinutes}分`;
    }
    return "";
  };

  const renderStartEndTime = () => {
    if (workingTime.workingTimeStart && workingTime.workingTimeEnd) {
      return `${getTime(workingTime.workingTimeStart)}～${getTime(workingTime.workingTimeEnd)}`;
    }
    return EMPTY_STR.TEXT;
  };

  const renderBreakTime = () => {
    if (workingTime.workingTimeBreakTime && workingTime.workingTimeBreakTime > 0) {
      const formattedBreakTime = String(workingTime.workingTimeBreakTime).padStart(2, "0");
      return `${formattedBreakTime}分`;
    }
    return EMPTY_STR.TEXT;
  };

  const renderTotalTime = () => {
    const totalTime = calculateWorkingTimeItem(workingTime);
    if (!workingTime.workingTimeBreakTime) {
      return EMPTY_STR.TEXT;
    }
    const formattedHours = String(totalTime.hours).padStart(2, "0");
    const formattedMinutes = String(totalTime.minutes).padStart(2, "0");
    return `${formattedHours}時間${formattedMinutes}分`;
  };

  const RenderPartial: FCC<{ label: string; required: boolean }> = ({ label, required, children }) => {
    return (
      <Stack direction="column" gap={1}>
        <Typography variant="cap12Light" color={black[70]}>
          {label}
          {required && (
            <Typography component="span" variant="cap12" sx={{ color: red[700], ml: 0.5 }}>
              *
            </Typography>
          )}
        </Typography>
        <Stack direction="row" justifyContent="space-between">
          <Typography
            variant="body14Semi"
            color={text.primary}
            sx={{
              fontFamily: "inherit",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {children}
          </Typography>
        </Stack>
      </Stack>
    );
  };
  return (
    <InnerBox title={<Typography variant="sub16Bold">{title}</Typography>} mb={2} showDivider={showDivider}>
      <Grid container>
        <Grid item xs={4}>
          <RenderPartial label="始業／終業" required>
            {renderStartEndTime()}
          </RenderPartial>
        </Grid>
        <Grid item xs={4}>
          <RenderPartial label="休憩時間" required={false}>
            {renderBreakTime()}
          </RenderPartial>
        </Grid>
        <Grid item xs={4}>
          <RenderPartial label="所定労働時間" required={false}>
            {renderTotalTime()}
          </RenderPartial>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
